export default __webpack_public_path__ + "static/media/walk_board.aa167618.png";